import { Directive, HostListener, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[fileInput]',
  exportAs: 'fileInput'
})
export class FileInputDirective implements OnInit, OnDestroy {
  @Input() control: FormControl;
  @Input() fileTypes: string; // .doc,.docx,application/msword
  @Input() maxFileSize: string;

  fileInputControl: HTMLInputElement;
  public files: File[] = [];

  constructor(private renderer: Renderer2) {
    this.initFileInputControl();
  }

  ngOnInit(): void {
    this.renderer.listen(this.fileInputControl, 'change', e => this.setFiles(e));
  }

  ngOnDestroy(): void {
    this.renderer.removeChild(this.fileInputControl.parentNode, this.fileInputControl);
  }

  deleteFile(i: number) {
    const files = this.files.slice();
    files.splice(i, 1);
    this.files = files;

    if (this.control) {
      this.control.patchValue(files);
    }
  }

  @HostListener('click')
  private onClick(): void {
    this.fileInputControl.click();
  }

  private initFileInputControl(): void {
    const fileInputControl: HTMLInputElement = this.renderer.createElement('input');
    this.renderer.setAttribute(fileInputControl, 'type', 'file');
    this.renderer.setAttribute(fileInputControl, 'multiple', 'true');
    this.renderer.setStyle(fileInputControl, 'display', 'none');

    if (this.fileTypes) {
      this.renderer.setAttribute(fileInputControl, 'accept', this.fileTypes);
    }

    this.fileInputControl = fileInputControl;
  }

  private setFiles(e): void {
    const newFiles = this.files.slice();
    const fileList: FileList = e.target.files;
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);
      if (file.size > 10000000) {
        // don't add files greater than 10MB
        continue;
      }

      newFiles.push(file);
    }

    this.files = newFiles;
    if (this.control) {
      this.control.patchValue(this.files);
      this.control.markAsDirty();
    }
  }
}
